import React from "react"
import { Space, Typography } from "antd"

import { W0 } from "@components"
import { validateDob } from "@components/Date"
import { getAddressSchema } from "@components/Address"
import { TYPE_NONE, TYPE_TIMEZONE } from "@components/Form"

import { updateMyImmutableAccountInvestorOperation as updateOperation } from "@api/services/investments"

import { LABEL_ACCREDITATION_NOTE, ACCREDITATION_REFERENCE_URL } from "./getUpdateMyAccountSchema"

const { Text, Link } = Typography

const LABEL_TIMEZONE = "Time Zone"


const getUpdateImmutableAccountSchema = ({
  address,
  dateOfBirth,
  hasAccreditation,
  updateSchema,
}) => {
  const dateOfBirthInput = !!dateOfBirth
    ? { name: "dateOfBirth", type: TYPE_NONE }
    : {
        name: "dateOfBirth",
        label: "Date of Birth",
        placeholder: "06/21/1990",
        required: true,
        itemProps: {
          rules: [validateDob()]
        }
      }

  const hasAccreditationInput = hasAccreditation !== undefined
    ? { name: "hasAccreditation", type: TYPE_NONE }
    : {
        name: "hasAccreditation",
        label: "Are you an accredited investor?",
        required: true,
        itemProps: {
          style: { marginBottom: 0 },
          extra: (
            <Space
              size={0}
              style={{ marginTop: W0, lineHeight: 1.2 }}
              direction="vertical"
            >
              <Text type="secondary" style={{ fontSize: 12 }}>
                {LABEL_ACCREDITATION_NOTE}{' '}
              </Text>

              <Link
                href={ACCREDITATION_REFERENCE_URL}
                target="_blank"
                style={{ fontSize: 12 }}
              >
                {ACCREDITATION_REFERENCE_URL}
              </Link>
            </Space>
          )
        }
      }

  const schema = updateOperation.getSchema([
    {
      name: "alternativeName",
      label: "Preferred Name",
    },
    dateOfBirthInput,
    {
      name: "mobileNumber",
    },
    {
      name: "address",
      label: "",
      schema: getAddressSchema(updateSchema, ["address"], address),
    },
    {
      name: "timeZoneCode",
      type: TYPE_TIMEZONE,
      label: LABEL_TIMEZONE,
      required: false,
    },
    hasAccreditationInput,
    {
      name: "landNumber",
      type: TYPE_NONE,
    },
  ])

  return schema
}

export default getUpdateImmutableAccountSchema
